import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
const steps = [{
  number: 1,
  title: 'Discovery & Consultation',
  description: 'We start by listening. We take time to understand your business, your goals, and your challenges so we can recommend the right digital solutions.',
  icon: 'https://cdn.magicpatterns.com/uploads/7re4NnMHDaNx3m5mSZTNvR/Group_4.svg'
}, {
  number: 2,
  title: 'Strategy & Planning',
  description: 'Once we know what you need, we map out a clear strategy – from creative direction to timelines and resources – ensuring everyone is on the same page before we begin.',
  icon: 'https://cdn.magicpatterns.com/uploads/p1dmdmQ2MQDcDRUB4VP838/Layer_1_1_.svg'
}, {
  number: 3,
  title: 'Design & Development',
  description: "This is where we do our magic. We build the solution to address your actual problem. Whether it's designing visuals, building websites, or creating marketing campaigns, we bring concepts to life.",
  icon: 'https://cdn.magicpatterns.com/uploads/e5AqZXZNDTfeJiefdt9cNr/Grodfgvcdup.svg'
}, {
  number: 4,
  title: 'Testing & Delivery',
  description: 'Before anything goes live, we test thoroughly to ensure everything works perfectly. Then, we deliver the project to you – polished, functional, and ready to make an impact.',
  icon: 'https://cdn.magicpatterns.com/uploads/gt3iKd3FWAqfqthTrqXFfA/Expand.svg'
}, {
  number: 5,
  title: 'Ongoing Support',
  description: "Our relationship doesn't end at delivery. We provide ongoing support, updates, and guidance to help you get the most out of your new digital solution.",
  icon: 'https://cdn.magicpatterns.com/uploads/n1WimTmPbEqX5UrBY3zLQu/Gradient_Line.svg'
}];
export function ProcessSection() {
  return <Section id="process" background="white" data-id="element-299">
      {/* Header */}
      <div className="mb-16" data-id="element-300">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-bold font-heading text-[#0C0C0C] mb-6" data-id="element-301">
          Our work Process
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-gray-600 leading-relaxed max-w-2xl" data-id="element-302">
          We believe a great project starts with understanding the{' '}
          <span className="bg-[#FF6600]/20 px-1 text-[#FF6600] font-medium" data-id="element-303">
            real problem
          </span>{' '}
          and ends with ongoing support. Here's how we bring your ideas to life:
        </motion.p>
      </div>

      {/* Timeline */}
      <div className="relative" data-id="element-304">
        {/* Center vertical line (desktop only) */}
        <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-[#00316B]/20 -translate-x-1/2" data-id="element-305" />

        {/* Steps */}
        <div className="space-y-12 md:space-y-0" data-id="element-306">
          {steps.map((step, index) => {
          const isOdd = step.number % 2 === 1;
          const delay = index * 0.15;
          return <div key={step.number} className="relative" data-id="element-307">
                {/* Desktop Layout */}
                <div className="hidden md:grid md:grid-cols-2 md:gap-8 md:py-8" data-id="element-308">
                  {isOdd ? <>
                      {/* Left side: Number + Icon */}
                      <motion.div initial={{
                  opacity: 0,
                  x: -30
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay,
                  duration: 0.5
                }} className="flex items-center justify-end gap-4 pr-8" data-id="element-309">
                        <div className="w-12 h-12 rounded-full border-2 border-[#00316B] flex items-center justify-center text-[#00316B] font-bold text-lg shrink-0" data-id="element-310">
                          {step.number}
                        </div>
                        <img src={step.icon} alt="" className="w-14 h-14 object-contain" data-id="element-311" />
                      </motion.div>

                      {/* Right side: Title + Description */}
                      <motion.div initial={{
                  opacity: 0,
                  x: 30
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: delay + 0.1,
                  duration: 0.5
                }} className="pl-8" data-id="element-312">
                        <h3 className="text-xl font-bold font-heading text-[#FF6600] mb-3" data-id="element-313">
                          {step.title}
                        </h3>
                        <p className="text-gray-600 leading-relaxed max-w-md" data-id="element-314">
                          {step.description}
                        </p>
                      </motion.div>
                    </> : <>
                      {/* Left side: Title + Description */}
                      <motion.div initial={{
                  opacity: 0,
                  x: -30
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: delay + 0.1,
                  duration: 0.5
                }} className="text-right pr-8" data-id="element-315">
                        <h3 className="text-xl font-bold font-heading text-[#FF6600] mb-3" data-id="element-316">
                          {step.title}
                        </h3>
                        <p className="text-gray-600 leading-relaxed max-w-md ml-auto" data-id="element-317">
                          {step.description}
                        </p>
                      </motion.div>

                      {/* Right side: Number + Icon */}
                      <motion.div initial={{
                  opacity: 0,
                  x: 30
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay,
                  duration: 0.5
                }} className="flex items-center gap-4 pl-8" data-id="element-318">
                        <div className="w-12 h-12 rounded-full border-2 border-[#00316B] flex items-center justify-center text-[#00316B] font-bold text-lg shrink-0" data-id="element-319">
                          {step.number}
                        </div>
                        <img src={step.icon} alt="" className="w-14 h-14 object-contain" data-id="element-320" />
                      </motion.div>
                    </>}
                </div>

                {/* Mobile Layout */}
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay,
              duration: 0.5
            }} className="md:hidden" data-id="element-321">
                  <div className="flex items-center gap-4 mb-4" data-id="element-322">
                    <div className="w-12 h-12 rounded-full border-2 border-[#00316B] flex items-center justify-center text-[#00316B] font-bold text-lg shrink-0" data-id="element-323">
                      {step.number}
                    </div>
                    <img src={step.icon} alt="" className="w-12 h-12 object-contain" data-id="element-324" />
                  </div>
                  <h3 className="text-xl font-bold font-heading text-[#FF6600] mb-3" data-id="element-325">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-326">
                    {step.description}
                  </p>
                </motion.div>
              </div>;
        })}
        </div>
      </div>
    </Section>;
}